module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/design-tile-images/design-tile-03-744df12acd787752aa46baee93f0968e.jpg";